import React from 'react';
import { CtaButton } from './CtaButton';
import { ProductVisual } from './ProductVisual';
const chips = ['6 Volumes', '134 ready-to-run sessions', '42 worksheets', '5 Bonuses', '3 levels per session', '5 · 10 · 20+ min'];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'Open one page, run the session'];
const audiences = [{
  name: 'Students',
  color: 'bg-amber',
  text: 'text-ink'
}, {
  name: 'Club',
  color: 'bg-teal',
  text: 'text-white'
}, {
  name: 'Adults',
  color: 'bg-coral',
  text: 'text-white'
}];
export function Hero() {
  return <section className="stage relative w-full overflow-hidden text-white" data-id="element-119" data-mp="x8jo5qqjiyjb">
      <div className="spotlight pointer-events-none absolute inset-0" aria-hidden="true" data-id="element-120" data-mp="s9ggdyj6ee7n" />
      <div className="relative mx-auto w-full max-w-6xl px-4 pb-12 pt-6 sm:px-5 sm:pb-16 lg:pb-20 lg:pt-12" data-id="element-121" data-mp="nboov5mg0u3z">
        <div className="grid gap-7 lg:grid-cols-[1.05fr_.95fr] lg:items-center lg:gap-x-14 lg:gap-y-6" data-id="element-122" data-mp="3d2tqbf4z2uh6">
          <div className="lg:col-start-1 lg:row-start-1" data-id="element-123" data-mp="384jssxvrzhse">
            <p className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-[10px] font-semibold uppercase tracking-[1.6px] text-ink sm:text-[11px]" data-id="element-124" data-mp="3j9ka79gurdf2">
              <span className="h-2 w-2 rounded-full bg-coral" aria-hidden="true" data-id="element-125" data-mp="39albailw2w59" />
              52 Weeks of Speaking · for speaking teachers &amp; coaches
            </p>
            <h1 className="mt-4 font-display text-[40px] font-extrabold leading-[1.02] tracking-tight text-white sm:text-6xl lg:text-[60px] xl:text-[66px]" data-id="element-126" data-mp="3ebisosz2rm5p">
              Never plan a speaking class{' '}
              <span className="mark-hl-dark" data-id="element-127" data-mp="35au9zkyqkxmh">from scratch again.</span>
            </h1>
          </div>

          <div className="lg:col-start-1 lg:row-start-2" data-id="element-128" data-mp="2qi0kd6pr3143">
            <p className="max-w-xl text-[15px] leading-relaxed text-white/80 sm:text-base lg:text-lg" data-id="element-129" data-mp="2vjpxqt0g3qvc">
              A full year of ready-to-run public speaking sessions. Open the page,
              read the short facilitator script, and teach it in minutes — for
              students, clubs or adult learners. No more Sunday-night prep. No
              more running out of ideas.
            </p>

            <div className="mt-6 w-full max-w-md lg:mx-0" data-id="element-130" data-mp="najhbnrq6df0">
              <CtaButton data-id="element-131" data-mp="ibyowaipsy14">Get 52 Weeks of Speaking</CtaButton>
            </div>
          </div>

          <div className="lg:col-start-2 lg:row-span-4 lg:row-start-1 lg:self-center" data-id="element-132" data-mp="ddf3cb819o9a">
            <ProductVisual className="w-full max-w-[640px] lg:max-w-none" data-id="element-133" data-mp="1b0vx1kt7peg5" />
          </div>

          <div className="lg:col-start-1 lg:row-start-3" data-id="element-134" data-mp="1ayjiziqkro8d">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-135" data-mp="16346ov87u0e2">
              <ul className="flex gap-1.5" aria-label="Every session is tagged for three rooms" data-id="element-136" data-mp="111ol9224lrv5">
                {audiences.map(a => <li key={a.name} className={`rounded-full px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider ${a.color} ${a.text}`} data-id="element-137" data-mp="x37cyf6yybc5">
                    {a.name}
                  </li>)}
              </ul>
              <p className="max-w-sm text-xs leading-relaxed text-white/70" data-id="element-138" data-mp="1xb5omas9olej">
                Built for <span className="font-semibold text-white" data-id="element-139" data-mp="21bfttl88j7sc">speech &amp; ESL teachers, speaking coaches and club leaders</span>{' '}
                in the US, UK, Canada &amp; Australia
              </p>
            </div>

            <ul className="mt-5 grid gap-2 text-xs text-white/65 sm:flex sm:flex-wrap sm:gap-x-5" data-id="element-140" data-mp="2b2soslpbye2l">
              {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-141" data-mp="2kydtirls9sg1">
                  <span className="h-1.5 w-1.5 flex-none rounded-full bg-amber" data-id="element-142" data-mp="2l0qbv5vge4tm" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-start-1 lg:row-start-4" data-id="element-143" data-mp="2tysic0xyhpoa">
            <ul className="flex flex-wrap gap-1.5 sm:gap-2" data-id="element-144" data-mp="un98zl8qqfe3">
              {chips.map(chip => <li key={chip} className="rounded-full border border-white/20 bg-ink-deep/50 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide text-white/75 sm:px-3 sm:py-1.5 sm:text-[11px]" data-id="element-145" data-mp="zkr8ym4s5k9y">
                  {chip}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
      <div className="wave-strip h-1.5 w-full" aria-hidden="true" data-id="element-146" data-mp="9ah2n2i02jxn" />
    </section>;
}